import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';
import { ViewType } from '../GoalProgress/GoalProgress';

// Hooks
import { useGoal } from 'Shared/utils/hooks/use-goal';

// Components
import GoalProgressWrapper from '../GoalProgressWrapper/GoalProgressWrapper';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

type Props = {
  goal: GoalItem;
  showEmptyState?: boolean;
  includeType?: boolean;
  view?: ViewType;
};

const GoalSubGoalProgress = ({ goal, showEmptyState = false, view = 'table' }: Props) => {
  const { subGoals } = useGoal({ slug: goal.slug });
  const hasSubGoals = subGoals.length > 0;
  if (!hasSubGoals && showEmptyState)
    return (
      <EmptyStateContainer
        subTitle="Create sub-goals to start tracking progress"
        grayBackground
        padding="025"
        inContainer
      />
    );

  if (!hasSubGoals) return null;

  const totalNumberOfCompleteSubGoals = subGoals.filter(goal => goal.complete).length;
  const totalNumberOfSubGoals = subGoals.length;

  const percent = Math.round((totalNumberOfCompleteSubGoals * 100) / totalNumberOfSubGoals);

  if (view === 'table') return <GoalProgressWrapper percent={percent} />;
  if (view === 'panel')
    return (
      <GoalProgressWrapper
        percent={percent}
        topLabel={{
          label: `${percent}%`,
          size: 'md',
        }}
        bottomLabel={{ label: `${totalNumberOfCompleteSubGoals} of ${totalNumberOfSubGoals} sub-goals complete` }}
      />
    );
  if (view === 'page')
    return (
      <GoalProgressWrapper
        percent={percent}
        progressBarSize="md"
        inlineEndLabel={{
          label: `${totalNumberOfCompleteSubGoals} of ${totalNumberOfSubGoals} complete`,
          size: 'sm',
        }}
        topLabel={{
          label: `${percent}%`,
          size: 'lg',
        }}
      />
    );
};

export default GoalSubGoalProgress;
